<script>
  import * as PropTypes from "prop-types";
  import SvgWrapper from "@/components/atoms/SvgWrapper.svelte";
  import SvgMusicNote from "$assets/svg/ic_music_note.svg?src";
  import Avatar from "@/components/atoms/Avatar.svelte";
  import AudioItem from "@/components/molecules/AudioItem.svelte";
  import { onMount } from "svelte";

  export let item;
  const { checkPropTypes, object, string } = PropTypes;
  const propTypes = {
    item: object,
    audioId: string,
  };
  onMount(() => {
    checkPropTypes(propTypes, $$props, "prop", "Audio");
  });
</script>

<div class="flex mb-10 px-xs">
  <div class="max-w-full w-[100px] h-[100px] md:w-[148px] md:h-[148px]">
    <Avatar
      src={item.audioMeta?.thumbUrl}
      width=" w-[100px] md:w-[148px]"
      height=" h-[100px] md:h-[148px]"
      flexShrink="shrink"
    />
  </div>

  <div class="w-[300px] pl-5 md:pl-10 overflow-hidden">
    <div
      class="flex items-center text-[16px] md:text-[24px] font-bold"
      data-testid="audio-icon"
    >
      <SvgWrapper
        className="inline-block w-xl h-xl mr-sm my-xs"
        svg={SvgMusicNote}
      />
      <p class="break-words" data-testid="audio-name">
        {item.audioMeta?.audioName}
      </p>
      {#if item.removeThis}
        <img class="h-[22px] w-[22px] ml-xs" src={item.badgeUrl} alt="Badge" />
      {/if}
    </div>
    <div
      class="text-[14px] md:text-[15px] font-bold mt-xxs break-words"
      data-testid="audio-text"
    >
      {item.audioMeta?.audioText}
    </div>
    <div class="flex flex-wrap my-lg" data-testid="audio-item">
      <AudioItem {item} />
    </div>
  </div>
</div>
